//@ts-check
import React from 'react';

/**
 * @type {React.FC<{children:React.ReactNode}>}
 */
export const CardSectionContainer = ({ children }) => {
  return (
    <div className="flex flex-col w-full h-full p-6 gap-4">
      {children}
    </div>
  );
};

